export const invalidEmailStrings = [
  'notengo@gmail.com',
  'notiene.notiene@hotmail.com',
  'notiene@SSS.COM',
  'notiene@correo.com',
  'notiene@ejemplo.com',
  'notiene@es.com',
  'notiene@gmail.com',
  'notiene@hormail.com',
  'notiene@hotmai.com',
  'notiene@hotmail.com.es',
  'notiene@hotmail.es',
  'notiene@hotrmai.com',
  'notiene@msn.com',
  'notiene@ppd.com',
  'notiene@pth.com',
  'notiene@sura.com',
  'notiene@sura.com.co',
  'notiene@tiene.com',
  'notiene@xxxx.com',
  'notiene@xxxx.xxx',
  'notiene@xxxxxx.com',
  'notiene@yahoo.com',
  'notienec@rr.com',
  'notienecorero@hotmail.com',
  'notienecorre@hotmail.com',
  'notienecorreo.d@hotmail.com',
  'notienecorreo1@gmail.com',
  'notienecorreo@gmail.com',
  'notienecorreo@hotmail.com',
  'notienecorreo@notiene.com',
  'notienecorreo@ppd.com',
  'notienecorreo@urc.com',
  'notienecorreog@gmail.com',
  'notienecorrreo@com.co',
  'notienesuracliente@hotmail.com',
  'notitne@hotmail.com',
  'nr@gmail.com',
  'nr@hotmail.com',
  'pxxxxx@yahoo.com',
  'sincorreo.com@gmail.com',
  'sincorreo@ppd.com',
  'sincorreo@sura.com',
  'sincorreo@suracliente.com.co',
  'sincorreoclientesura@gmail.com',
  'sincorreosura@sura.com.co',
  'sincorreosuracliente@gmail.com',
  'sincorreosuracliente@hotmail.com',
  'www.ellelesu@hotmail.com',
  'www.elpaisa@hotmail.com',
  'www.jjovejo@hotmail.com',
  'www.juanessm@gmail.com',
  'xxx@hotmail.com',
  'xxx@xx.x',
  'xxxx@gmail.com',
  'xxxx@yahoo.com',
  'xxxxx@ejemplo.com',
  'xxxxx@gmail.com',
  'xxxxx@kjk.com',
  'xxxxx@xx.com',
  'xxxxxx11@hotmail.com',
  'xxxxxx@hotmial.com',
  'xxxxxx@notiene.com',
  'xxxxxx@suramericana.com.co',
  'xxxxxx@xxxxx.xxx',
  'xxxxxx@yahoo.es',
  'xxxxxxx@hotmail.com',
  'xxxxxxxx@hotmail.com',
  'xxxxxxxx@xxx.xx',
  'xxxxxxxx@xxxxxx.com',
  'xxxxxxxxx@hotmail.com',
  'xxxxxxxxxx@gmail.com',
  'xxxxxxxxxxx@hotmail.com',
  'xxxxxxxxxxxxx@hotmail.com',
  '0000@HOTMAIL.COM',
  '000@000.COM',
  '111111@HOTMAIL.COM',
  '123@NOTIENE.COM',
  '123@hotmail.com',
  '123@hotmail.no',
  '1@hotmail.com',
  '99999999@9999999.com',
  'A2A@A.COM',
  'A@A.COM',
  'A@A.COM.CO',
  'A@AL.COM',
  'A@ASURA.COM.CO',
  'A@HOTMAIL.COM',
  'AAA@GMAIL.COM',
  'CLIENTENOTIENE@XXXXX.COM',
  'NO@AA.COM',
  'NO@GMAIL.COM',
  'NO@HOTMAIL.COM',
  'NO@PECYCIA.COM',
  'NOAPORTA@HOTMAIL.COM',
  'NODISPONIBLE@XXXXXX.COM',
  'NONE@NONE.COM',
  'NOPAORTA@GMAIL.COM',
  'NOREGISTRA@GMAIL.COM',
  'NOTENGO@HOTMAIL.COM',
  'NOTIEEN@HOTMAIL.COM',
  'NOTIEN@HOTMAIL.COM',
  'NOTIENE3@HOTMAIL.COM',
  'NOTIENE@HOTMAIL.COM',
  'NOTIENE@NINGUNO.COM',
  'NOTIENE@NO.COM',
  'NOTIENE@NOTIEN.COM',
  'NOTIENE@NOTIENE.COM',
  'NOTIENE@NOTINE.COM',
  'NOTIENE@NT.COM',
  'NOTIENE@SURAMERICANA.COM',
  'NOTIENE@XXXXX.XXX',
  'NOTIENE@XXXXXXX.COM',
  'NOTIENEC@HOTMAIL.COM',
  'NOTIENECOREE@HOTMAIL.COM',
  'NOTIENECORREO@COM.CO',
  'NOTIENECORREO@YAHOO.COM',
  'NOTUENE@HOTMAIL.COM',
  'RF@RF.COM',
  'SINCORREO@GMAIL.COM',
  'SINCORREO@HOTMAIL.COM',
  'SINCORREO@SURA.COM.CO',
  'WWW.JM@HOTMAIL.ES',
  'XXX@XXXX.XXX',
  'XXXX@HOTMAIL.COM',
  'XXXX@ICLOUD.COM',
  'XXXX@XXX.COM',
  'XXXX@XXX.XXX',
  'XXXX@XXXX.COM',
  'XXXX@XXXX.XXX',
  'XXXX@XXXXX.XXX',
  'XXXXX@HOTMAIL.COM',
  'XXXXX@XXXX.XXX',
  'XXXXX@XXXXX.XXX',
  'XXXXXX@GMAIL.COM',
  'XXXXXX@HOTMAIL.COM',
  'XXXXXX@XXXX.XXX',
  'XXXXXXX@AAAA.COM',
  'XXXXXXX@XXXX.XXX',
  'XXXXXXX@XXXXX.XXX',
  'XXXXXXX@YAHOO.COM',
  'XXXXXXXX@XXXXX.COM',
  'XXXXXXXXX@GMAIL.COM',
  'XXXXXXXXXX@HOTMAIL.COM',
  'Xxxxxxxxx@xxxxxxx.xxx',
  'a@a.co',
  'a@sura.com.co',
  'a@yahoo.com',
  'aaa@ariasaristizabalabogados.com',
  'aaq@aa.aaa',
  'adf@gmail.com',
  'noaporta@mail.com',
  'noasignadossff@sura.com.co',
  'noinforma@hotmail.com',
  'nopresenta@ppd.com',
  'noregistra@hotmail.com',
  'noregistra@noregistra.com',
  'noregistra@sura.com.co',
  'noregistra@yahoo.com',
  'noregistracorreo@hotmail.com',
  'nosuministra@hotmail.com',
  'nosuministra@yahoo.com',
  'nosumintracorreo@hotmail.com',
];

export const invalidAddressString = [
  'NO APLICA',
  'NO DESEA REGISTRARLA',
  'NO INFORMA',
  'NO REGISTRA DIRECCION',
  'NO REPORTA',
  'REGISTRO SIN DIRECCION',
  'SIN DIRECCION',
  'SIN DIRECCIÓN',
  'SIN INFORMACION',
  'SIN INFORMACION @',
  'SIN INFORMACION AGRICOLA',
  'SIN INFORMACIÓN',
  'SIN NOMENCLATURA',
];

export const invalidFirstNameString = [
  '    ---',
  '------',
  '--------------------',
  'AAA',
  'AAAAAAA',
  'ABCD ABCD',
  'ASDS',
  'BASURA',
  'BBB',
  'CIA',
  'DEPARTAMENTO',
  'DGFG',
  'DPTO',
  'ERRADA',
  'ERRADO',
  'GGG',
  'HDHD',
  'HERRADO',
  'JAJAJAJA',
  'JJJ',
  'JJJJ',
  'KKK',
  'LIMITADA',
  'LLLL',
  'LTD.',
  'LTDA',
  'MMM',
  'MMMM',
  'NA',
  'NN',
  'NNN',
  'NO SE SABE',
  'NOMBRE',
  'NULL',
  'NULO',
  'OTRO',
  'PRUEBA',
  'S.A.',
  'SA.',
  'SDFSDFSDF',
  'SIN',
  'SSSS',
  'USUARIO',
  'XXX',
  'XXXX',
  'XXXXX',
  'XXXXXXX',
  'XXXXXXXXX',
  'JAJAJAJA',
  'ABCD ABCD ',
  'AAAAAAA',
  'BB',
  'BBBBBBB',
  'BBB',
  'CEL',
  'CC',
  'CCCCC',
  'DE',
  'DDD',
  'EEEEHHHH',
  'EH',
  'EEEE',
  'FEE',
  'FFFFF',
];

export const invalidSecondNameString = [
  '    ---',
  '------',
  '--------------------',
  'AAA',
  'AAAAAAA',
  'ABCD ABCD',
  'ASDS',
  'BASURA',
  'BBB',
  'CIA',
  'DEPARTAMENTO',
  'DGFG',
  'DPTO',
  'ERRADA',
  'ERRADO',
  'GGG',
  'HDHD',
  'HERRADO',
  'JAJAJAJA',
  'JJJ',
  'JJJJ',
  'KKK',
  'LIMITADA',
  'LLLL',
  'LTD.',
  'LTDA',
  'MMM',
  'MMMM',
  'NA',
  'NN',
  'NNN',
  'NO SE SABE',
  'NOMBRE',
  'NULL',
  'NULO',
  'OTRO',
  'PRUEBA',
  'S.A.',
  'SA.',
  'SDFSDFSDF',
  'SIN',
  'SSSS',
  'USUARIO',
  'XXX',
  'XXXX',
  'XXXXX',
  'XXXXXXX',
  'XXXXXXXXX',
];

export const invalidFirstLastNameString = [
  '    ---',
  '------',
  '--------------------',
  'AAA',
  'AAAAAAA',
  'ABCD ABCD',
  'ASDS',
  'BASURA',
  'BBB',
  'CIA',
  'DEPARTAMENTO',
  'DGFG',
  'DPTO',
  'ERRADA',
  'ERRADO',
  'GGG',
  'HDHD',
  'HERRADO',
  'JAJAJAJA',
  'JJJ',
  'JJJJ',
  'KKK',
  'LIMITADA',
  'LLLL',
  'LTD.',
  'LTDA',
  'MMM',
  'MMMM',
  'NA',
  'NN',
  'NNN',
  'NO SE SABE',
  'NOMBRE',
  'NULL',
  'NULO',
  'OTRO',
  'PRUEBA',
  'S.A.',
  'SA.',
  'SDFSDFSDF',
  'SIN',
  'SSSS',
  'USUARIO',
  'XXX',
  'XXXX',
  'XXXXX',
  'XXXXXXX',
  'XXXXXXXXX',
];

export const invalidSecondLastNameString = [
  '    ---',
  '------',
  '--------------------',
  'AAA',
  'AAAAAAA',
  'ABCD ABCD',
  'ASDS',
  'BASURA',
  'BBB',
  'CIA',
  'DEPARTAMENTO',
  'DGFG',
  'DPTO',
  'ERRADA',
  'ERRADO',
  'GGG',
  'HDHD',
  'HERRADO',
  'JAJAJAJA',
  'JJJ',
  'JJJJ',
  'KKK',
  'LIMITADA',
  'LLLL',
  'LTD.',
  'LTDA',
  'MMM',
  'MMMM',
  'NA',
  'NN',
  'NNN',
  'NO SE SABE',
  'NOMBRE',
  'NULL',
  'NULO',
  'OTRO',
  'PRUEBA',
  'S.A.',
  'SA.',
  'SDFSDFSDF',
  'SIN',
  'SSSS',
  'USUARIO',
  'XXX',
  'XXXX',
  'XXXXX',
  'XXXXXXX',
  'XXXXXXXXX',
];
